import { toCdn } from '../utils/cdn';

export const projectMeta = {
  marketplace: {
    title: 'Facebook Marketplace',
    shortTitle: 'Marketplace',
    date: '2017-2022',
    role: 'Lead Designer',
    screenImage: toCdn('/images/screens/marketplace.png'),
    description: 'Leading design initiatives for Facebook Marketplace.',
    firstImage: toCdn('/images/projects/marketplace/marketplace_1.webp')
  },
  aiproxy: {
    title: 'AIProxy',
    shortTitle: 'AIProxy',
    date: '2024-Present',
    role: 'Cofounder',
    screenImage: toCdn('/images/screens/aiproxy.png'),
    url: 'https://www.aiproxy.com',
    description: 'A serveice that helps app developers secure their API keys.',
    firstImage: toCdn('/images/projects/aiproxy/aiproxy_1.webp')
  },
  letterfall: {
    title: 'Letterfall',
    shortTitle: 'Letterfall',
    date: '2022',
    role: 'Creator',
    screenImage: toCdn('/images/screens/letterfall.png'),
    url: 'https://letterfallgame.com',
    description: 'An iOS game that combines elements of Scrabble and Tetris.',
    firstImage: toCdn('/images/projects/letterfall/letterfall_1.webp')
  },
  golfgoals: {
    title: 'Golf Goals',
    shortTitle: 'Golf Goals',
    date: '2025',
    role: 'Creator',
    screenImage: toCdn('/images/screens/golfgoals.png'),
    url: 'https://apps.apple.com/us/app/golf-goals-shot-tracer/id6745529338',
    description: 'An app to track golfing goals and achievements.',
    firstImage: toCdn('/images/projects/golfgoals/golfgoals_1.webp')
  },
  abc: {
    title: 'ABC Finder',
    shortTitle: 'ABC Finder',
    date: '2011-2012',
    role: 'Creator',
    screenImage: toCdn('/images/screens/abc.png'),
    url: 'https://abcfinder.app',
    description: 'An alphabet learning game using Core ML object detection.',
    firstImage: toCdn('/images/projects/abcfinder/abcfinder_1.webp')
  },
  swiftui: {
    title: 'SwiftUI Prototypes',
    shortTitle: 'SwiftUI',
    date: '2023-Present',
    screenImage: toCdn('/images/screens/swiftui.png'),
    description: 'A collection SwiftUI prototypes and experiments.',
    firstImage: toCdn('/images/projects/swiftui/swiftui_1.webp')
  },
  facebook: {
    title: 'Facebook Developer Tools',
    shortTitle: 'Facebook',
    date: '2016-2024',
    role: 'Product Designer',
    screenImage: toCdn('/images/screens/facebook.png'),
    description: 'The Facebook Like Button, Social Plugins, and Developer Site.',
    firstImage: toCdn('/images/projects/facebook/facebook_1.webp')
  },
  joypad: {
    title: 'Joypad',
    shortTitle: 'Joypad',
    date: '2011-2013',
    role: 'Cofounder',
    screenImage: toCdn('/images/screens/joypad.png'),
    description: 'An app and SDK for game developers to turn any phone into a game controller.',
    firstImage: toCdn('/images/projects/joypad/joypad_1.webp')
  },
  figma: {
    title: 'Figma to Swift',
    shortTitle: 'Figma → Swift',
    date: '2021',
    role: 'Creator',
    screenImage: toCdn('/images/screens/figma.png'),
    url: 'https://figmatoswift.com',
    description: 'A plugin that exports your design tokens to a Swift package.',
    firstImage: toCdn('/images/projects/figma/figma_poster.webp')
  },
  archive: {
    title: 'Archive',
    shortTitle: 'Archive',
    date: '2011-2025',
    screenImage: toCdn('/images/screens/archive.png'),
    description: 'A collection on random experiments, shaders, and prototypes.',
    firstImage: toCdn('/images/projects/archive/swiftIcon.webp'),
    icon: 'archive'
  }
};

// Centralized order for menu and other listings
export const projectOrder = [
  'marketplace',
  'aiproxy',
  'letterfall',
  'golfgoals',
  'abc',
  'swiftui',
  'facebook',
  'joypad',
  'figma',
  'archive'
];


